import { memo, useEffect, useState } from "react";

import noop from "lodash/noop";
import { useDispatch, useSelector } from "react-redux";

import { BasicModal } from "@similarweb/ui-components";

import { generateAutomationName } from "app/pages/benchmark-tracker/helpers/helpers";
import { closeSubscriptionModal } from "app/pages/benchmark-tracker/store/actions/report";
import { selectIsSubscriptionModalOpen } from "app/pages/benchmark-tracker/store/selectors/reportSelectors";

import { SubscribeSettingsContent } from "./components/SubsribeContent";
import { UnsubscribeContent } from "./components/UnsubscribeContent";
import { modalStyles } from "./constants";

type SubscriptionModalSchema = {
    isViewerMode: boolean;
};

export const SubscriptionModal = memo(({ isViewerMode }: SubscriptionModalSchema) => {
    const isOpen = useSelector(selectIsSubscriptionModalOpen);
    const dispatch = useDispatch();

    const [isUnsubscribe, setIsUnsubscribe] = useState(false);

    const onClose = () => {
        dispatch(closeSubscriptionModal());
    };

    const onUnsubscribe = () => {
        setIsUnsubscribe(true);
    };

    useEffect(() => {
        if (!isOpen) {
            setIsUnsubscribe(false);
        }
    }, [isOpen]);

    return (
        <BasicModal
            isOpen={isOpen}
            onRequestClose={onClose}
            customStyles={modalStyles}
            closeIconConfig={{
                show: false,
                onClick: noop,
            }}
            dataAutomation={generateAutomationName("report", ["subscription-modal"])}
        >
            {isUnsubscribe ? (
                <UnsubscribeContent isViewerMode={isViewerMode} />
            ) : (
                <SubscribeSettingsContent
                    onUnsubscribe={onUnsubscribe}
                    isViewerMode={isViewerMode}
                />
            )}
        </BasicModal>
    );
});

SubscriptionModal.displayName = "SubscriptionModal";
